import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { 
  ITituloResponse, 
  ITituloRequest, 
  ITituloSaveRequest, 
  ITituloSaveResponse,
  ISuccessResponse
} from '../interfaces/titulo.interface';

@Injectable({
  providedIn: 'root'
})
export class TituloService {
  private readonly API_URL = `${environment.apiNewBackBaseUrl}MntoSolicitudes/GetTitls4`;
  private readonly API_URL_SAVE = `${environment.apiNewBackBaseUrl}MntoSolicitudes/GetTitlsErr`;
  private readonly API_URL_DETAIL = `${environment.apiNewBackBaseUrl}Titulos/cmspa_titulosDetail`;
  private readonly API_URL_UPDATE = `${environment.apiNewBackBaseUrl}Titulos/cmspa_titulosUpd`;
  private readonly API_URL_DELETE = `${environment.apiNewBackBaseUrl}Titulos/cmspa_titulosDelete`;

  constructor(private http: HttpClient) { }

  getTitulos(): Observable<ITituloResponse> {
    const payload: ITituloRequest = {
      que: 4,
      tope: "999",
      titulo: "",
      descripcion: "",
      score: 0,
      sujeto_de_credito: ""
    };
    return this.http.post<ITituloResponse>(this.API_URL, payload);
  }

  getTituloDetail(titulo: string): Observable<ITituloResponse> {
    const payload: ITituloRequest = {
      que: 5,
      tope: "",
      titulo: titulo,
      descripcion: "",
      score: 0,
      sujeto_de_credito: ""
    };
    return this.http.post<ITituloResponse>(this.API_URL, payload);
  }

  saveTitulo(titulo: ITituloRequest): Observable<ITituloSaveResponse> {
    const payload: ITituloRequest = {
      que: 1,
      tope: "",
      titulo: titulo.titulo,
      descripcion: titulo.descripcion,
      score: 0,
      sujeto_de_credito: ""
    };
    return this.http.post<ITituloSaveResponse>(this.API_URL_SAVE, payload);
  }

  updateTitulo(titulo: ITituloRequest): Observable<ITituloSaveResponse> {
    const payload = {
      que: 2,
      tope: "",
      titulo: titulo.titulo,
      descripcion: titulo.descripcion,
      score: 0,
      sujeto_de_credito: ""
    };

    return this.http.post<ITituloSaveResponse>(this.API_URL_SAVE, payload);
  }

  deleteTitulo(titulo: string): Observable<ITituloSaveResponse> {
    const payload = {
      que: 3,
      tope: "",
      titulo: titulo,
      descripcion: "",
      score: 0,
      sujeto_de_credito: ""
    };

    return this.http.post<ITituloSaveResponse>(this.API_URL_SAVE, payload);
  }
} 